import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSticker"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C12.3748 2 12.7451 2.02066 13.1099 2.06098L13.4588 2.09956L21.9004 10.5412L21.939 10.8901C21.9793 11.2549 22 11.6252 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20 12C14.5 13 11 9.5 12 4L20 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSticker;
